module.exports = __webpack_public_path__ + "static/assets/e7e7cdeac62aa40f71af104718bc95f1.png";